const { UTM_CONTENT_PARAMETER, UTM_SOURCE_PARAMETER } = require('../constants/ProfileConstants');

const UTM_PARAM_PATTERN = /^utm_/;

function getUtmContent() {
    if (typeof window === 'undefined') return null;

    const utmContent = new URLSearchParams(window.location.search).get(UTM_CONTENT_PARAMETER);
    if (utmContent) {
        try {
            window.sessionStorage.setItem(UTM_CONTENT_PARAMETER, utmContent);
        } catch (e) {
            // Ignore unavailable sessionStorage; this request still carries the URL value.
        }
        return utmContent;
    }

    try {
        return window.sessionStorage.getItem(UTM_CONTENT_PARAMETER);
    } catch (e) {
        return null;
    }
}

function addUtmContentToUrl(url) {
    const utmContent = getUtmContent();
    if (!utmContent || !url) return url;

    try {
        const isAbsoluteUrl = /^[a-z][a-z\d+\-.]*:/i.test(url);
        const parsedUrl = new URL(url, window.location.origin);
        if (!parsedUrl.searchParams.has(UTM_CONTENT_PARAMETER)) {
            parsedUrl.searchParams.set(UTM_CONTENT_PARAMETER, utmContent);
        }

        return isAbsoluteUrl ? parsedUrl.toString() : `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
    } catch (e) {
        return url;
    }
}

function getUtmSource() {
    if (typeof window === 'undefined') return null;

    const utmSource = new URLSearchParams(window.location.search).get(UTM_SOURCE_PARAMETER);
    if (utmSource) {
        try {
            window.sessionStorage.setItem(UTM_SOURCE_PARAMETER, utmSource);
        } catch (e) {
            // Ignore unavailable sessionStorage; this request still carries the URL value.
        }
        return utmSource;
    }

    try {
        return window.sessionStorage.getItem(UTM_SOURCE_PARAMETER);
    } catch (e) {
        return null;
    }
}

function addUtmSourceToUrl(url) {
    const utmSource = getUtmSource();
    if (!utmSource || !url) return url;

    try {
        const isAbsoluteUrl = /^[a-z][a-z\d+\-.]*:/i.test(url);
        const parsedUrl = new URL(url, window.location.origin);
        if (!parsedUrl.searchParams.has(UTM_SOURCE_PARAMETER)) {
            parsedUrl.searchParams.set(UTM_SOURCE_PARAMETER, utmSource);
        }

        return isAbsoluteUrl ? parsedUrl.toString() : `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
    } catch (e) {
        return url;
    }
}

function addUtmSourceToParams(params) {
    const utmSource = getUtmSource();
    if (!utmSource) return params;

    return {
        ...params,
        [UTM_SOURCE_PARAMETER]: params?.[UTM_SOURCE_PARAMETER] || utmSource,
    };
}

function captureUtmParams() {
    if (typeof window === 'undefined') return;
    try {
        const params = new URLSearchParams(window.location.search);
        params.forEach((value, key) => {
            if (UTM_PARAM_PATTERN.test(key) && value) {
                window.sessionStorage.setItem(key, value);
            }
        });
    } catch (e) {}
}

function getStoredUtmParams() {
    if (typeof window === 'undefined') return {};
    const result = {};
    try {
        new URLSearchParams(window.location.search).forEach((value, key) => {
            if (UTM_PARAM_PATTERN.test(key) && value) result[key] = value;
        });
    } catch (e) {}
    try {
        Object.keys(window.sessionStorage).forEach((key) => {
            if (UTM_PARAM_PATTERN.test(key) && !(key in result)) {
                const value = window.sessionStorage.getItem(key);
                if (value) result[key] = value;
            }
        });
    } catch (e) {}
    return result;
}

function addUtmParamsToUrl(url) {
    const utmParams = getStoredUtmParams();
    if (!url || Object.keys(utmParams).length === 0) return url;
    try {
        const isAbsoluteUrl = /^[a-z][a-z\d+\-.]*:/i.test(url);
        const parsedUrl = new URL(url, window.location.origin);
        Object.entries(utmParams).forEach(([key, value]) => {
            if (!parsedUrl.searchParams.has(key)) parsedUrl.searchParams.set(key, value);
        });
        return isAbsoluteUrl ? parsedUrl.toString() : `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
    } catch (e) {
        return url;
    }
}

function addUtmDataToUrl(url, condition = true) {
    if (!condition) return url;
    return addUtmParamsToUrl(url);
}

module.exports = {
    getUtmContent,
    addUtmContentToUrl,
    getUtmSource,
    addUtmSourceToUrl,
    addUtmSourceToParams,
    captureUtmParams,
    getStoredUtmParams,
    addUtmParamsToUrl,
    addUtmDataToUrl,
};
